import { LayerDefinition } from './types';

export const snowDepthDefinition: LayerDefinition = {
  id: 'snow_depth',
  name: 'Snow Depth & SNOTEL',
  category: 'environment',
  categoryLabel: 'Hydrology & Mountain Weather',
  icon: '❄️',
  description: 'High-resolution NOAA SNODAS 1km snow depth analysis with live USDA NRCS SNOTEL and Canadian ECCC / BC snow station telemetry.',
  sourceModels: ['NOAA SNODAS 1km Snow Analysis', 'USDA NRCS SNOTEL Telemetry', 'ECCC & BC Snow Pillow Network'],
  outputModels: ['Continuous mountain snowpack gradient', 'Live SNOTEL observation stations']
};

export default snowDepthDefinition;
